import type { AppProps } from "next/app";
import HomeReduxProvider from "@potoo-modules/functions/home-redux-provider";
import useChannelTalk from "@potoo-modules/hooks/useChannelTalk";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ToastBox } from "@/components/ToastBox";

// ui-styles
import "@ui-components/styles/card.scss";
import "@ui-components/styles/color.scss";
import "@ui-components/styles/common.scss";
import "@ui-components/styles/components.scss";
import "@ui-components/styles/footer.scss";
import "@ui-components/styles/icon.css";
import "@ui-components/styles/table.scss";
import "@ui-components/styles/toast.scss";
import "@ui-components/styles/typography.scss";

// styles
import "@/styles/global.css";
import "@/styles/button.scss";
import "@/styles/header.scss";
import "@/styles/sections.scss";
import "@/styles/plan-sections.scss";
import "@/styles/customer-sections.scss";
import "@/styles/landing-typography.scss";
import "@/styles/carousel.scss";
import "@/styles/rollingbanner.scss";
import "@/styles/before-after.scss";
import ServiceMetaHead from "@/components/ServiceMetaHead";
import { LanguageContextProvider } from "@/contexts/language";
import { BannerProvider } from "@/contexts/BannerContext";
//for notion styling
// core styles shared by all of react-notion-x (required)
import "react-notion-x/src/styles.css";
// // used for code syntax highlighting (optional)
import "prismjs/themes/prism-tomorrow.css";
// // used for rendering equations (optional)
import "katex/dist/katex.min.css";

function App({ Component, pageProps, router }: AppProps) {
  useChannelTalk();

  return (
    <>
      <ServiceMetaHead path={router.asPath || "/ko"} />
      <HomeReduxProvider>
        <LanguageContextProvider>
          <BannerProvider>
            <Header />
            <Component {...pageProps} />
            <ToastBox />
            <Footer />
          </BannerProvider>
        </LanguageContextProvider>
      </HomeReduxProvider>
    </>
  );
}

export default App;
